<template>
  <div class="mood-page">
    <div class="container">
      <h1 class="h1">{{ $t("mood.title") }}</h1>

      <WhiteHolder :class="{ error: v$.form.mood.$error }">
        <MoodPicker v-model="moodObject" ref="moodPicker" />
      </WhiteHolder>

      <WhiteHolder v-for="(item, index) in moodQuestions" :key="index">
        <Question
          :question="item.question"
          :answers="item.answers"
          v-model="form[item.model]"
        />
        <div
          v-if="item.model == 'pav' && form.pav == 1"
          class="textarea-holder"
        >
          <textarea
            v-model="form.pav_comment"
            :placeholder="$t('common.comment_placeholder')"
            class="form-textarea"
          />
        </div>
        <div
          v-if="item.model == 'meds' && form.meds == 1"
          class="med__list"
        >

            <div v-for="(med, i) in avaiableMeds" :key="i">

                <a  href="#" class="med__title" @click.prevent="form.meds_data[i].enabled = !form.meds_data[i].enabled">  <custom-checkbox  v-model="form.meds_data[i].enabled"></custom-checkbox> <span  v-text="med"></span></a>
                <div v-if="form.meds_data[i].enabled" class="med-item" >
                    <custom-dropdown
                        v-model="form.meds_data[i].size"
                        :options="sizes"
                        placeholder="Выберите дозировку"
                    />
                    <custom-dropdown
                        v-model="form.meds_data[i].freq"
                        :options="freqs"
                        placeholder="Выберите дозировку"
                    />
                </div>
            </div>
            <textarea
                v-model="form.meds_comment"
                placeholder="Другие лекарства"
                class="form-textarea"
            />


        </div>
      </WhiteHolder>

      <WhiteHolder>
        <Question question="Что произошло в этот день" />
        <textarea
          v-model="form.comment"
          placeholder="Напиши все, что важно и я помогу тебе проанализировать события дня"
          class="form-textarea"
        />
      </WhiteHolder>
    </div>

    <div class="page-footer">
      <van-button
        type="primary"
        icon-position="right"
        class="button-white button-right-icon"
        @click="submitForm"
      >
        <template v-if="!loading">
          {{ $t("common.finish") }}
        </template>
        <template v-else>
          <van-loading />
        </template>
        <template #icon>
          <img src="@/assets/images/light-arrow-right.svg" alt="..." />
        </template>
      </van-button>
      <van-button
        type="primary"
        icon-position="left"
        class="button-white button-left-icon"
        @click="prevStep"
      >
        {{ $t("common.btn_back") }}
        <template #icon>
          <img src="@/assets/images/light-arrow-left.svg" alt="..." />
        </template>
      </van-button>
    </div>
    <van-notify v-model="showFormError" type="danger">
      <span>{{ $t("dialog.error_data_1") }}</span>
    </van-notify>
  </div>
</template>

<script>
import WhiteHolder from "@/components/WhiteHolder";
import Question from "@/components/Question";
import MoodPicker from "@/components/MoodPicker";
import moodQuestions from "@/mixins/moodQuestions.js";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from 'axios';
import CustomDropdown from '@/components/CustomDropdown.vue';
import CustomCheckbox from '@/components/CustonCheckbox.vue';

export default {
  components: {
      CustomCheckbox,
      CustomDropdown,
    WhiteHolder,
    Question,
    MoodPicker,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [moodQuestions],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {},
      moodObject: {},
      showFormError: false,
      loading: false,
      avaiableMeds: [],
      freqs: [
          { label: "1 раз в день", value: 1 },
          { label: "2 раза в день", value: 2 },
          { label: "3 раза в день", value: 3 },
          { label: "4 раза в день", value: 4 },
          { label: "5 раз в день", value: 5 }
      ],
      sizes: [
          { label: "0.5 таблетки", value: 0.5 },
          { label: "1 таблетка", value: 1 },
          { label: "2 таблетки", value: 2 },
          { label: "3 таблетки", value: 3 },
          { label: "4 таблетки", value: 4 },
          { label: "5 таблеток", value: 5 }
      ]
    };
  },
  validations() {
    return {
      form: {
        mood: {
          required,
        },
      },
    };
  },
  async mounted() {
      this.form = this.data[0];
      this.moodObject = this.data[1];

      this.$refs.moodPicker.selectedMood = this.form.mood;

      const url = new URL(window.location.href);
      const t = url.searchParams.get("gender") == "female" ? true : false;

      const moodQuestions = this.moodQuestions;
      await this.fetchMeds()

      if (this.form.menstruation == undefined) {
          this.moodQuestions = moodQuestions.filter((item) => {
              return item.model !== "menstruation";
          });
      }

      if (t) {
          this.moodQuestions = moodQuestions.filter((item) => {
              return item;
          });
      }
  },
  methods: {
      async fetchMeds() {
         const {data} = await axios
              .get(
                  `https://hm.tgapp.live/self?token=${this.$route.query.token}`,
                  {
                      headers: {
                          "Access-Control-Allow-Origin": "*",
                          "Access-Control-Allow-Methods":
                              "GET,PUT,POST,DELETE,PATCH,OPTIONS",
                      },
                  }
              );
            console.log(data)
          this.avaiableMeds = data.data;
          this.avaiableMeds.forEach((item) => {
              if(this.form.meds_data.length === 0) {
                  this.form.meds_data.push({
                      title: item,
                      size: this.sizes[0].value,
                      freq: this.freqs[0].value,
                      enabled: false
                  });
              }else{
                  const weItem = this.form.meds_data.find(itemData => itemData.title === item);
                  if (!weItem) {
                      this.form.meds_data.push({
                          title: item,
                          size: this.sizes[0].value,
                          freq: this.freqs[0].value,
                          enabled: false
                      });
                  }
              }
          })
      },
    async submitForm() {
      this.form.mood = this.moodObject.value;
      if (this.form.mood) {
        this.form.mood = this.moodObject.value;
      }

      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) {
        this.showNotify();

        return;
      }

      this.ifAnswerZero();

      let exportData = [{ ...this.form }, { ...this.moodObject }];

      console.log(exportData);

      this.$emit("onComplete", exportData);
    },
    showNotify() {
      this.showFormError = true;
      setTimeout(() => {
        this.showFormError = false;
      }, 2000);
    },
    ifAnswerZero() {
      this.moodQuestions.forEach((el) => {
        if (!this.form[el.model] && this.form[el.model] !== 0) {
          this.form[el.model] = -1;
        }
      });
    },
    prevStep() {
      this.$emit("prevStep");
    },
  },
};
</script>

<style lang="scss" scoped>
.mood-page {
  .container {
    padding-left: 14px;
    padding-right: 16px;
  }

  .page-footer {
    padding-top: 20px;
    padding-right: 34px;
    padding-left: 46px;

    .button-white {
      &:first-child {
        margin-bottom: 14px;
      }
    }
  }

    .med__list{
        padding-top: 16px;

        .med-item{
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 16px;
        }
        .med__title{
            display: flex;
            gap: 8px;
            align-items: center;
            margin-bottom: 12px;
            span {
                font-size: 16px;
                display: block;
                color: #000;

            }
        }
    }

  .textarea-holder {
    padding-top: 9.95px;
  }
}
</style>
